import { Field } from 'react-final-form';
import { jsx as _jsx } from "react/jsx-runtime";
export function baseFieldRenderer(_ref) {
  let {
    name,
    mktSelector
  } = _ref;
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    className: "form-control form-control-lg",
    "data-mkt-selector": mktSelector?.value,
    "data-qa-selector": mktSelector?.value
  });
}